module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp1_4.a3e4199d.png";